var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/BimEntity/BimModel.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { Id } from '../Id';
import { Version } from '../Version';
import { BimFile } from '../ModelRepo';
import { ApiDomain } from '../domain';
import { ModelErrorCodeType } from '../ModelErrorCodeType';
import { BimCategory } from './BimCategory';
import { ForgeData, ForgeRefs } from './ForgeRefs';
import { BimModelElementSource } from './BimModelElementSource';
import { ViewerRefs } from './ViewerRefs';
export var BimModel;

(function (_BimModel) {
  var domain = ApiDomain.domain('BimModel', {
    name: "domain",
    sid: "-grwwz"
  });
  var ModelType = t.union([t.literal('AssemblyModel'), t.literal('ForgeModel'), t.literal('GstationModel')]);
  var CommonFields = t.type({
    type: t.literal('BimModel'),
    id: Id,
    version: Version,
    modelType: ModelType,
    forgeData: t.union([ForgeData, t["null"]]),
    author: t.union([t.string, t["null"]]),
    uploadDate: t.string,
    name: t.string,
    total: t.number,
    source: BimModelElementSource,
    errorCode: t.union([t["null"], t.undefined, ModelErrorCodeType])
  }, 'BimModelCommonFields');

  var ioBuilder = _BimModel.ioBuilder = function (status) {
    return t.intersection([CommonFields, t.type({
      status: status
    })]);
  };

  var io = _BimModel.io = t.intersection([CommonFields, t.type({
    forgeRefs: ForgeRefs,
    viewerRefs: ViewerRefs,
    status: BimFile.Status.ImportCompleted
  })]);

  var is = _BimModel.is = function (entity) {
    return entity.type === 'BimModel' && entity.status === 'ImportCompleted';
  };

  var isLoadedOrNotLoaded = _BimModel.isLoadedOrNotLoaded = function (entity) {
    return entity.type === 'BimModel';
  };

  var fetchLatestBimFile = _BimModel.fetchLatestBimFile = ApiCallService.create({
    name: 'fetchLatestBimFile',
    parentDomain: domain,
    result: BimFile.io,
    getKey: ['modelId']
  });
  var ImportError = t.intersection([CommonFields, t.type({
    forgeRefs: t.union([ForgeRefs, t["null"]]),
    viewerRefs: t.union([ViewerRefs, t["null"]]),
    status: BimFile.Status.ImportError
  })], 'BimModelImportError');
  var ImportInProgress = t.intersection([CommonFields, t.type({
    forgeRefs: t.union([ForgeRefs, t["null"]]),
    viewerRefs: t.union([ViewerRefs, t["null"]]),
    status: BimFile.Status.ImportInProgress
  })], 'BimModelImportInProgress');
  var NotImported = t.intersection([CommonFields, t.type({
    forgeRefs: t.union([ForgeRefs, t["null"]]),
    viewerRefs: t.union([ViewerRefs, t["null"]]),
    status: BimFile.Status.NotImported
  })], 'BimModelNotImported');
  var NotLoaded;

  (function (_NotLoaded) {
    var io = _NotLoaded.io = t.union([ImportError, ImportInProgress, NotImported], 'BimModelNotLoaded');

    var is = _NotLoaded.is = function (entity) {
      return entity.type === 'BimModel' && entity.status !== 'ImportCompleted';
    };
  })(NotLoaded || (NotLoaded = _BimModel.NotLoaded || (_BimModel.NotLoaded = {})));

  var fetchViewerRefs = _BimModel.fetchViewerRefs = ApiCallService.create({
    name: 'fetchViewerRefs',
    parentDomain: domain,
    result: ViewerRefs,
    getKey: ['modelId', 'modelVersion', 'id', 'type']
  });
  var Populated;

  (function (_Populated) {
    var io = _Populated.io = t.type({
      type: t.literal('BimModelPopulated'),
      id: Id,
      version: Version,
      modelType: ModelType,
      forgeData: t.union([ForgeData, t["null"]]),
      author: t.union([t.string, t["null"]]),
      uploadDate: t.string,
      status: BimFile.Status.ImportCompleted,
      name: t.string,
      total: t.number,
      forgeRefs: ForgeRefs,
      viewerRefs: ViewerRefs,
      children: t.readonlyArray(BimCategory.io),
      offset: t.number,
      source: BimModelElementSource,
      errorCode: t.union([t["null"], t.undefined, ModelErrorCodeType])
    }, 'BimModelPopulated');

    var is = _Populated.is = function (entity) {
      return entity.type === 'BimModelPopulated';
    };

    var fetch = _Populated.fetch = ApiCallService.create({
      name: 'fetch',
      parentDomain: domain,
      result: Populated.io,
      getKey: ['key']
    });
  })(Populated || (Populated = _BimModel.Populated || (_BimModel.Populated = {})));
})(BimModel || (BimModel = {}));